import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import { InMemoryCache } from 'apollo-cache-inmemory';

Vue.use(VueApollo);

const modulo = window.localStorage.getItem('revista.modulo');
const uf = window.localStorage.getItem('@revista:default') ? window.localStorage.getItem('@revista:default') : window.localStorage.getItem('revista.uf');
const param = modulo === 'syscor' ? `?estado=${uf}` : '';

const AUTH_TOKEN = 'access_token';

const httpDefault = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_HTTP_DEFAULT + param,
};

const httpRevista = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_HTTP_REVISTA + param,
};

const httpTabela = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_HTTP_TABELA + param,
};

const httpNoticiaTemp = {
  httpEndpoint: process.env.VUE_APP_GRAPHQL_HTTP_NOTICIA_TEMP,
};

const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: process.env.VUE_APP_GRAPHQL_WS,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  cache: new InMemoryCache(),

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
};

const tempOptions = {
  wsEndpoint: process.env.VUE_APP_GRAPHQL_WS,
  tokenName: null,
  persisting: false,
  websocketsOnly: false,
  ssr: false,
  cache: new InMemoryCache(),
};

export function createProvider(options = {}) {
  /**
   * Conexão DEFAULT - GraphQL
   */
  const { apolloClient: clientDefault, wsClient: wsDefault } = createApolloClient({
    ...defaultOptions,
    ...httpDefault,
    ...options,
  });
  /**
   * Conexão Revista - GraphQL
   */
  const { apolloClient: clientRevista } = createApolloClient({
    ...defaultOptions,
    ...httpRevista,
    ...options,
  });
    /**
     * Conexão Revista - Notícia TEMP
     */
    const { apolloClient: clientNoticiaTemp } = createApolloClient({
        ...tempOptions,
        ...httpNoticiaTemp,
        ...options,
    });
  /**
   * Tabela de Preço
   */
  const { apolloClient: clientTabela } = createApolloClient({
    ...defaultOptions,
    ...httpTabela,
    ...options,
  });

  clientDefault.wsClient = wsDefault;

  window.$apollo = clientDefault;

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    clients: {
      default: clientDefault,
      revista: clientRevista,
      tabela: clientTabela,
      noticiaTemp: clientNoticiaTemp,
    },
    defaultClient: clientDefault,
    defaultOptions: {
      $query: {
        fetchPolicy: 'no-cache',
      },
    },
    errorHandler(error) {
      console.log(error);
      // eslint-disable-next-line no-console
      console.log(
        '%cError',
        'background: red; color: white; padding: 2px 4px; border-radius: 50px; font-weight: bold;',
        error.message,
      );
    },
  });

  return apolloProvider;
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token);
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message);
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN);
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
  }
}
